import { ChangeDetectionStrategy, Component, Inject, Input, LOCALE_ID } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Store } from '@ngxs/store';
import { OperationObserverService } from '@x/common/operation';
import { IShopSubscriberAgreement } from '@x/ecommerce/shop-client';
import { SubscriberUpdateDeclaration } from '../../state/subscriber.actions';

@Component({
  selector: 'x-subscriber-agreement',
  templateUrl: './subscriber-agreement.component.html',
  styleUrls: ['./subscriber-agreement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-subscriber-agreement' },
})
export class SubscriberAgreementComponent {
  private operationQ$ = this.operationService.createQueue();
  private _agreement: IShopSubscriberAgreement;
  @Input() set agreement(agreement: IShopSubscriberAgreement) {
    this._agreement = agreement;
    this.formControl.setValue(Boolean(agreement.agreed));
  }

  get agreement() {
    return this._agreement;
  }

  formControl = new FormControl(false, { nonNullable: true });

  onAgreementChange(event: MatCheckboxChange, agreement: IShopSubscriberAgreement) {
    this.operationQ$.queue(
      this.store.dispatch(
        new SubscriberUpdateDeclaration({
          agreements: [{ id: agreement.id, agreed: event.checked }],
          locale: this.locale,
        }),
      ),
    );
  }

  constructor(
    private store: Store,
    private operationService: OperationObserverService,
    @Inject(LOCALE_ID) private locale: string,
  ) {}
}
